import { getStartPageInfo } from "../../services/MainService";
const state = {
  startPageInfo: [],
};
const getters = {
  allStartCards: (state) => state.startPageInfo,
};
const actions = {
  async fetchStartCards({ commit }) {
    const response = await getStartPageInfo();
    commit("setStartCards", response.data.featuredRows);

    // record interaction for data tracking
    const interactionData = {
      eventType: "displayStartPage",
      eventData: {}
    };
    this.dispatch('recordInteraction', interactionData, { root: true })
  },
};
const mutations = {
  setStartCards: (state, startPageInfo) => (state.startPageInfo = startPageInfo),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
